module.exports = __webpack_public_path__ + "img/userD02.b3b94ca1.jpg";